import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {
  Button,
  Link,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography
} from '@material-ui/core';
import { Text } from 'recharts';
import { bindActionCreators } from 'redux';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { sendLogin, signOut } from '../../auth/Auth';
import ShopEditShop from './ShopEditShop';
import { getShopDetail } from '../../actions/Shop';
import { removeToken } from '../../libs/apis/UserApi';
import {
  GET_BANK_BRANCH_LIST_SUCCESS,
  GET_BANK_LIST_SUCCESS,
  getBankList,
  getBankBranchList
} from '../../actions/Bank';

const styles = theme => ({
  hidden: {
    display: 'none'
  },
  font12: {
    fontSize: 12
  },
  font14: {
    fontSize: 14
  },
  bold: {
    fontWeight: 'bold'
  },
  mt20: {
    marginTop: 20
  },
  page: {
    paddingTop: 20,
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: theme.spacing(1)
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  pagerInDiv: {
    padding: 20
  },
  redText: {
    color: '#FF0000'
  },
  tableTitle: {
    fontSize: 16,
    marginBottom: '20px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #E0E0E0',
    backgroundColor: '#F7F7F7',
    width: '115px',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 700
  },
  tableCellData: {
    borderBottom: '1px solid #E0E0E0',
    padding: '13px 8px',
    fontSize: 12,
    fontWeight: 500
  },
  noteText: {
    fontSize: 12,
    paddingTop: 10,
    fontWeight: 600
  },
  textLabel: {
    fontSize: 12,
    fontWeight: 600
  },
  description: {
    color: '#707070',
    fontSize: 14
  },
  shopInfoContainer: {
    width: '90%',
    margin: 'auto',
    paddingTop: 20,
    paddingBottom: 10,
    whiteSpace: 'nowrap'
  },
  shopHeader: {
    backgroundColor: '#717171 !important',
    height: 'auto',
    minHeight: 22,
    marginBottom: 10,
    display: 'flex',
    alignItems: 'center'
  },
  tableInfo: {
    width: '100%',
    marginBottom: 10
  },
  tableInfoCellHeader: {
    padding: '5px 10px',
    width: '60px',
    borderBottom: '2px solid #ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#000000',
    backgroundColor: '#F7F7F7',
    whiteSpace: 'nowrap'
  },
  tableInfoCell: {
    padding: '2px 10px',
    borderBottom: '2px solid transparent',
    fontSize: '12px',
    whiteSpace: 'break-spaces'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  tableRowShopName: {
    paddingLeft: 16
  },
  titleGroupNameDiv: {
    padding: '5px 12px'
  },
  titleGroupName: {
    fontSize: 10,
    fontWeight: 'normal',
    lineHeight: '13px',
    color: 'rgba(255, 255, 255, 0.87)'
  },
  textGroupNameDiv: {
    padding: '5px 12px'
  },
  textGroupName: {
    fontSize: 12,
    lineHeight: '16px',
    color: '#fff',
    whiteSpace: 'break-spaces'
  },
  textShopId: {
    fontSize: 10,
    fontWeight: 'normal',
    lineHeight: '13px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  textShopName: {
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: '21px',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 5,
    whiteSpace: 'break-spaces'
  },
  paperContentItem: {
    margin: '20px auto'
  },
  iconOpenDoc: {
    width: 16
  },
  helpLink: {
    display: 'flex',
    fontSize: 14
  },
  linkToHome: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shop: state.shops.detail,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getShopDetail, getBankList, getBankBranchList },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('groupDepositManage', 'setGroupDepositManage', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefectures', 'setPrefectures', ''),
  withState('city', 'setCity', ''),
  withState('address', 'setAddress', ''),
  withState('address1', 'setAddress1', ''),
  withState('address2', 'setAddress2', ''),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('contactPhone', 'setContactPhone', ''),
  withState('phone', 'setPhone', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('priceRange', 'setPriceRange', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('shopCategoryId', 'setShopCategoryId', 0),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('snsFacebook', 'setSnsFacebook', ''),
  withState('snsTwitter', 'setSnsTwitter', ''),
  withState('snsInstagram', 'setSnsInstagram', ''),
  withState('showPhone', 'setShowPhone', 1),
  withState('childShopFlag', 'setChildShopFlag', 0),
  withState('accountStatus', 'setAccountStatus', 1),
  withState('paymentGroupType', 'setPaymentGroupType', ''),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('isShopCanEditSetting', 'setIsShopCanEditSetting', false),
  withState('shopDetail', 'setShopDetail', {}),
  withState('tags', 'setTags', []),
  withState('tagStr', 'setTagStr', ''),
  withState('images', 'setImages', []),
  withState('shopAnniversaries', 'setShopAnniversaries', []),
  withState('status', 'setStatus', ''),
  withState('statusStr', 'setStatusStr', ''),
  withState('stealthMode', 'setStealthMode', ''),
  withState('stealthModeStr', 'setStealthModeStr', ''),
  withState('gochiRestriction', 'setGochiRestriction', ''),
  withState('gochiRestrictionStr', 'setGochiRestrictionStr', ''),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState('depositManageStr', 'setDepositManageStr', '入金を自身で管理する'),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('inviteUserId', 'setInviteUserId', 0),
  withState('inviteUserStr', 'setInviteUserStr', ''),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('email', 'setEmail', ''),
  withState('bankSwitchable', 'setBankSwitchable', true),
  withState('createdAt', 'setCreatedAt', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('otherLanguages', 'setOtherLanguages', []),
  withState('bankCode', 'setBankCode', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('listBank', 'setListBank', []),
  withState('listBankBranch', 'setListBankBranch', []),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('groupRegistrationId', 'setGroupRegistrationId', 'T'),
  withState('paymentGroupId', 'setPaymentGroupId', null),
  withState('allowGapPayment', 'setAllowGapPayment', 0),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    account,
    show,
    handleRedirect,
    shop,
    shopCategories,
    checkSession,
    updateOpenProgress,
    openEditModal,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    groupDepositManage,
    setGroupDepositManage,
    shopId,
    setShopId,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    countryCode,
    setCountryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    prefectures,
    setPrefectures,
    city,
    setCity,
    address,
    setAddress,
    address1,
    setAddress1,
    address2,
    setAddress2,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    contactPhone,
    setContactPhone,
    phone,
    setPhone,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    priceRange,
    setPriceRange,
    access,
    setAccess,
    webPage,
    setWebPage,
    shopCategoryId,
    setShopCategoryId,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    snsFacebook,
    setSnsFacebook,
    snsTwitter,
    setSnsTwitter,
    snsInstagram,
    setSnsInstagram,
    showPhone,
    setShowPhone,
    childShopFlag,
    setChildShopFlag,
    accountStatus,
    setAccountStatus,
    paymentGroupType,
    setPaymentGroupType,
    cashAllowed,
    setCashAllowed,
    isShopCanEditSetting,
    setIsShopCanEditSetting,
    shopDetail,
    setShopDetail,
    tags,
    setTags,
    tagStr,
    setTagStr,
    images,
    setImages,
    shopAnniversaries,
    setShopAnniversaries,
    status,
    setStatus,
    statusStr,
    setStatusStr,
    stealthMode,
    setStealthMode,
    stealthModeStr,
    setStealthModeStr,
    gochiRestriction,
    setGochiRestriction,
    gochiRestrictionStr,
    setGochiRestrictionStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    inviteUserId,
    setInviteUserId,
    inviteUserStr,
    setInviteUserStr,
    cognitoUserId,
    setCognitoUserId,
    email,
    setEmail,
    bankSwitchable,
    setBankSwitchable,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    otherLanguages,
    setOtherLanguages,
    bankCode,
    setBankCode,
    bankBranchCode,
    setBankBranchCode,
    listBank,
    setListBank,
    listBankBranch,
    setListBankBranch,
    registrationId,
    setRegistrationId,
    groupRegistrationId,
    setGroupRegistrationId,
    paymentGroupId,
    setPaymentGroupId,
    allowGapPayment,
    setAllowGapPayment
  }) => {
    const detail = {
      otherLanguages,
      groupId,
      groupName,
      groupDepositManage,
      shopId,
      shopName,
      shopNameKana,
      countryCode,
      zipCode,
      prefectureCode,
      prefectures,
      city,
      address,
      address1,
      address2,
      building,
      shopGroupName,
      shopContactName,
      department,
      contactPhone,
      phone,
      businessHours,
      introduction,
      holiday,
      nearestStation,
      priceRange,
      access,
      webPage,
      tags,
      tagStr,
      images,
      shopAnniversaries,
      status,
      statusStr,
      stealthMode,
      stealthModeStr,
      gochiRestriction,
      gochiRestrictionStr,
      depositManage,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      inviteUserId,
      inviteUserStr,
      cognitoUserId,
      email,
      bankSwitchable,
      createdAt,
      updatedAt,
      shopCategories,
      shopCategoryId,
      numberSit,
      smoking,
      parking,
      snsFacebook,
      snsTwitter,
      snsInstagram,
      showPhone,
      childShopFlag,
      accountStatus,
      paymentGroupType,
      cashAllowed,
      shopDetail,
      isShopCanEditSetting,
      bankCode,
      bankBranchCode,
      registrationId,
      groupRegistrationId,
      paymentGroupId,
      allowGapPayment
    };

    const getShop = async id => {
      await actions.getShopDetail(id).then(detailData => {
        checkSession(detailData);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setGroupDepositManage(detailData.payload.groupDepositManage);
        setShopId(detailData.payload.shopId);
        setShopName(detailData.payload.shopName);
        setShopNameKana(detailData.payload.shopNameKana);
        setCountryCode(detailData.payload.countryCode);
        setZipCode(detailData.payload.zipCode);
        setPrefectureCode(detailData.payload.prefectureCode);
        setPrefectures(detailData.payload.prefectures);
        setCity(detailData.payload.city);
        setAddress(detailData.payload.address);
        setAddress1(detailData.payload.address1);
        setAddress2(detailData.payload.address2);
        setBuilding(detailData.payload.building);
        setShopGroupName(detailData.payload.shopGroupName);
        setShopContactName(detailData.payload.shopContactName);
        setDepartment(detailData.payload.department);
        setContactPhone(detailData.payload.contactPhone);
        setPhone(detailData.payload.phone);
        setIntroduction(detailData.payload.introduction);
        setBusinessHours(detailData.payload.businessHours);
        setHoliday(detailData.payload.holiday);
        setNearestStation(detailData.payload.nearestStation);
        setPriceRange(detailData.payload.priceRange);
        setAccess(detailData.payload.access);
        setWebPage(detailData.payload.webPage);
        setShopCategoryId(detailData.payload.shopCategoryId);
        setNumberSit(detailData.payload.numberSit);
        setSmoking(detailData.payload.smoking);
        setParking(detailData.payload.parking);
        setSnsFacebook(detailData.payload.snsFacebook);
        setSnsTwitter(detailData.payload.snsTwitter);
        setSnsInstagram(detailData.payload.snsInstagram);
        setShowPhone(detailData.payload.showPhone);
        setChildShopFlag(detailData.payload.childShopFlag);
        setAccountStatus(detailData.payload.accountStatus);
        setPaymentGroupType(detailData.payload.paymentGroupType);
        setCashAllowed(detailData.payload.cashAllowed);
        setIsShopCanEditSetting(detailData.payload.isShopCanEditSetting);
        setShopDetail(detailData.payload.shopDetail);
        setAllowGapPayment(detailData.payload.allowGapPayment);
        if (
          typeof detailData.payload.tags !== 'undefined' &&
          detailData.payload.tags !== null
        ) {
          setTags(detailData.payload.tags);
          setTagStr(
            detailData.payload.tags
              .map(tag => {
                return `${tag.tagName}`;
              })
              .join(' ')
          );
        }
        if (
          typeof detailData.payload.images !== 'undefined' &&
          detailData.payload.images !== null
        ) {
          setImages(detailData.payload.images);
        }
        if (
          typeof detailData.payload.shopAnniversaries !== 'undefined' &&
          detailData.payload.shopAnniversaries !== null
        ) {
          setShopAnniversaries(detailData.payload.shopAnniversaries);
        }
        setStatus(detailData.payload.status);
        setStatusStr(detailData.payload.statusStr);
        setStealthMode(detailData.payload.stealthMode);
        setStealthModeStr(detailData.payload.stealthModeStr);
        setGochiRestriction(detailData.payload.gochiRestriction);
        setGochiRestrictionStr(detailData.payload.gochiRestrictionStr);
        setDepositManage(detailData.payload.depositManage);
        setDepositManageStr(detailData.payload.depositManageStr);
        if (
          typeof detailData.payload.bankAccount !== 'undefined' &&
          detailData.payload.bankAccount !== null
        ) {
          setBankName(detailData.payload.bankAccount.bankName);
          setBankBranchName(detailData.payload.bankAccount.bankBranchName);
          setBankAccountType(detailData.payload.bankAccount.bankAccountType);
          setBankAccountTypeStr(
            detailData.payload.bankAccount.bankAccountTypeStr
          );
          setBankAccountNumber(
            detailData.payload.bankAccount.bankAccountNumber
          );
          setBankAccountHolder(
            detailData.payload.bankAccount.bankAccountHolder
          );
        }
        setInviteUserId(detailData.payload.inviteUserId);
        setInviteUserStr(detailData.payload.inviteUserStr);
        setCognitoUserId(detailData.payload.cognitoUserId);
        setEmail(detailData.payload.email);
        setBankSwitchable(detailData.payload.bankSwitchable);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        setOtherLanguages(detailData.payload.otherLanguages);
        setBankCode(detailData.payload.bankAccount.bankCode);
        setBankBranchCode(detailData.payload.bankAccount.bankBranchCode);
        setRegistrationId(detailData.payload.registrationId);
        setGroupRegistrationId(detailData.payload.groupRegistrationId);
        setPaymentGroupId(detailData.payload.paymentGroupId);
      });
    };

    const editOpenAction = async () => {
      updateOpenProgress(true);
      const bankResponse = await actions
        .getBankList()
        .then(data => checkSession(data));
      if (bankResponse.type === GET_BANK_LIST_SUCCESS) {
        setListBank(bankResponse.payload);
      } else {
        setListBank([]);
      }
      const bankBranchResponse = await actions
        .getBankBranchList()
        .then(data => checkSession(data));
      if (bankBranchResponse.type === GET_BANK_BRANCH_LIST_SUCCESS) {
        setListBankBranch(bankBranchResponse.payload);
      } else {
        setListBankBranch([]);
      }
      await getShop(account.shopId)
        .then(() => {
          updateOpenProgress(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          updateOpenProgress(false);
        });
    };

    const signOutAction = async () => {
      // remove token
      const currentToken = localStorage.getItem('firebaseToken');
      removeToken({
        pushToken: currentToken
      })
        .then(() => {
          console.log('remove token success');
        })
        .catch(() => {
          console.log('remove token failed');
        });

      signOut();
      handleRedirect('/');
    };

    return (
      <div className={show ? null : classes.hidden}>
        <div className={classes.page}>
          <div>
            <Typography className={classes.font14}>
              すべての情報が入力され、現在事務局審査中です。
            </Typography>
          </div>
          <div className={classes.titleGroup}>
            <Typography className={classes.font12}>
              ※審査はおおむね2〜3日程度で完了いたします。
            </Typography>
          </div>
          <div className={classes.titleGroup}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => handleRedirect('/release_review')}
            >
              審査状況を確認する
            </Button>
          </div>
          <Paper className={classes.paper} elevation={1}>
            <div className={classes.pagerInDiv}>
              <Typography className={classes.font14}>
                事務局審査中、掲載するメニューを登録できます。
              </Typography>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.mt20}
                onClick={editOpenAction}
              >
                店舗情報を登録・編集する
              </Button>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.mt20}
                onClick={() => handleRedirect('/gochi_menus_shop')}
              >
                メニューを登録・編集する
              </Button>
            </div>
          </Paper>
          <Paper className={`${classes.paper} ${classes.mt20}`} elevation={1}>
            <div className={classes.shopInfoContainer}>
              <div className={classes.shopHeader}>
                <div className={classes.titleGroupNameDiv}>
                  <Text className={classes.titleGroupName}>グループ名</Text>
                </div>
                <div className={classes.textGroupNameDiv}>
                  <Text className={classes.textGroupName}>
                    {shop.groupName}
                  </Text>
                </div>
              </div>
              <Typography className={classes.textShopId}>
                {`店舗ID: `}
                {shop.shopId}
              </Typography>
              <Typography className={classes.textShopName}>
                {shop.shopName}
              </Typography>
              <Table className={classes.tableInfo}>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableInfoCellHeader}>
                      住所
                    </TableCell>
                    <TableCell className={classes.tableInfoCell}>
                      {shop.prefectures}
                      {` `}
                      {shop.city}
                      {` `}
                      {shop.address1}
                      {` `}
                      {shop.address2}
                      {` `}
                      {shop.building}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableInfoCellHeader}>
                      電話番号
                    </TableCell>
                    <TableCell className={classes.tableInfoCell}>
                      {shop.phone}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </div>
          </Paper>
        </div>
        <div className={classes.paperContentItem}>
          <Link
            href="https://shop-guide.gochimeshi.com/"
            target="_blank"
            className={classes.helpLink}
          >
            サポートサイト
            <OpenInNewIcon className={classes.iconOpenDoc} />
          </Link>
        </div>
        <div className={classes.linkToHome}>
          <Button className={classes.button} onClick={signOutAction}>
            <Text className={[classes.bold, classes.font14]}>ログアウト</Text>
          </Button>
        </div>
        <Modal open={openEditModal} className={classes.modalMobile}>
          <ShopEditShop
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            editInput={detail}
            handleChangePage={() => {}}
            listBank={listBank}
            listBankBranch={listBankBranch}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
